import React from 'react';

import PersonIcon from '@mui/icons-material/Person';
import Box from '@mui/material/Box';

import { useUsers } from 'contexts/AuthContext';

import { KnzInlineProps } from '../../types';

/**
 * 社内ユーザーのメンション（`{{mention:userId}}` / `@userId`）。
 * User ストアから表示名を解決し、解決できなければ userId をそのまま表示する。
 * 記事詳細（ゲスト閲覧可）とワークスペース（認証必須）の両方で描画されるため useUsers を使う。
 */
export const UserMentionInline: React.FC<KnzInlineProps> = ({ value }) => {
  const users = useUsers();
  const user = users.find((u) => u.userId === value);
  const label = user?.userName ?? value;

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        verticalAlign: 'middle',
        whiteSpace: 'nowrap',
        textIndent: 0,
        gap: 0.25,
        px: 0.5,
        borderRadius: 1,
        bgcolor: 'action.hover',
        color: 'primary.main',
        fontWeight: 600,
        fontSize: '0.9em',
      }}
    >
      <PersonIcon sx={{ fontSize: '1em' }} />
      {label}
    </Box>
  );
};

export default UserMentionInline;
